export const appConfig = {
  // ayd: 'http://78.186.223.18:7079/api/v1.1',
  // algida: 'http://78.186.223.18:5005/api/v1.1',
  // kimlik: 'http://78.186.223.18:6002/api',
  // tokenUrl: 'http://78.186.223.18:8762/api',
  baseUrl: "https://defterdarbackend.yerlem.com"
};
